const VALIDITY_MESSAGE = {
  INPUT_ERROR_MESSAGE: '입력은 [ 숫자,숫자,숫자... ] 로 해주세요.',
  NOT_SAFE_INTEGER:
    '-9007199254740991 ~ 9007199254740991 사이의 값만 가능합니다.',
};

export default VALIDITY_MESSAGE;
